import { z } from 'zod';

export const CulinaryStudioArticleCategoryModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
});

export type CulinaryStudioArticleCategoryModel
= z.infer<typeof CulinaryStudioArticleCategoryModelSchema>;
